/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_ASSET_STATS_SUCCESS,
  GET_ASSET_STATS_FAILURE,
  UPDATE_INCOME_GOAL_SUCCESS,
  UPDATE_INCOME_GOAL_FAILURE,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE
} from "../actions/actionTypes";

const initialState = {
  assetStats: {},
  dashboardStats: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_STATS_SUCCESS:
      return {
        getAssetStatsSuccess: true,
        assetStats: action.payload.assetStats
      };
    case GET_ASSET_STATS_FAILURE:
      return {
        getAssetStatsSuccess: false,
        assetStats: state.assetStats
      };

    case GET_DASHBOARD_STATS_SUCCESS:
      return {
        getDashboardStats: true,
        dashboardStats: action.payload
      };
    case GET_DASHBOARD_STATS_FAILURE:
      return {
        getDashboardStats: false,
        dashboardStats: state.dashboardStats
      };
    case UPDATE_INCOME_GOAL_SUCCESS:
      return {
        updateIncomeGoalSuccess: true,
        dashboardStats: {
          ...state.dashboardStats,
          incomeGoal: action.payload.incomeGoal
        },
        getDashboardStats: true
      };

    case UPDATE_INCOME_GOAL_FAILURE:
      return {
        updateIncomeGoalSuccess: false,
        ...state
      };
    default:
      return state;
  }
}
